module.exports = "<p>{{t('actionWanDnsPlaceholder.defaultDns')|e}}</p>\n";
